module.exports = __webpack_public_path__ + "static/so-93ffa689f7cb6530c4e09a028197d082.jpg";